let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ax1Ia")).then(() => parcelRequire('fGkcz'));